import React from 'react';
import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
    title: string;
    subtitle?: React.ReactNode;
    icon?: React.ReactNode;
    action?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, icon, action }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            mb: 3,
            flexWrap: 'wrap',
            gap: 2,
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0, flex: 1 }}>
            {icon && (
                <Box sx={{ color: 'primary.main', display: 'flex', alignItems: 'center' }}>
                    {icon}
                </Box>
            )}
            <Box>
                <Typography variant="h5" component="h1" fontWeight={700} sx={{ wordBreak: 'break-word', fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                    {title}
                </Typography>
                {subtitle && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
        </Box>
        {action && (
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', '& .MuiButton-root': { fontSize: '0.8125rem', padding: '4px 10px' } }}>
                {action}
            </Box>
        )}
    </Box>
);

export default PageHeader;
